<template>

  <v-flex
    xs12
    class="mx-3">
    <v-checkbox
      :label="label"
      v-model="copiedDay.isActive"
      :input-value="copiedDay.isActive"
      :false-value="false"
      :true-value="true"
      :error-messages="dayError"
      color="success"/>

    <time-picker
      v-if="copiedDay.isActive"
      v-model="copiedDay.end_time"
      :allowed-hours="allowedHours"
      :allowed-menutes="allowedStep"
      :label="$t('endTime')"/>
  </v-flex>
</template>

<script>
import TimePicker from '@/components/global-components/inputs/TimePicker.vue'

export default {
  name: 'EmployeeSettingsSchemaDay',
  components: { TimePicker },
  props: ['day', 'label', 'endErrorMessage', 'dayError'],
  data () {
    return {
      dayMenu: false,
      copiedDay: {}
    }
  },
  methods: {
    allowedStep: m => m % 15 === 0,
    allowedHours: h => h > 8
  },
  watch: {
    day: {
      handler () {
        this.copiedDay = Object.assign({}, this.day)
      },
      deep: true,
      immediate: true
    },
    copiedDay: {
      handler () {
        this.$emit('change', this.copiedDay)
      },
      deep: true,
      immediate: true
    }
  },
  i18n: {
    messages: {
      en: {
        endTime: 'End time',
        startTime: 'Start time'
      },
      tr: {
        endTime: 'Bitiş zamanı',
        startTime: 'Başlangıç zamanı'
      },
      de: {
        endTime: 'Ende',
        startTime: 'Start'
      },
      ru: {
        endTime: 'Время окончания',
        startTime: 'Начальное время'
      }
    }
  }
}
</script>
